import { useParams } from "react-router-dom";
import { FiThumbsDown } from "react-icons/fi";

import { actions, hasPermission } from "../../services/security";

import Card from "../../components/ui/card";
import ListaNegraForm from "../../components/lista-negra/lista-negra-form";
import Header from "../../components/ui/header";

const ListaNegraDetailPage = () => {
  const { id } = useParams();

  const action =
    id === "nuevo"
      ? "Agregar a "
      : hasPermission(actions.ListaNegraEditar)
      ? "Editar"
      : "Ver";

  const title = `${action} Lista Negra`;
  const icon = <FiThumbsDown />;
  const breadcrumb = [
    { title: "Lista Negra", url: "/lista-negra" },
    { title: action, url: `/lista-negra/${id}` },
  ];

  return (
    <Card>
      <Header title={title} icon={icon} breadcrumb={breadcrumb} />
      <ListaNegraForm id={id} />
    </Card>
  );
};

export default ListaNegraDetailPage;
